"use client";

/**
 * Client component to initialize Sentry on the client side.
 * This ensures Sentry is only loaded in the browser, not during SSR.
 */
import { useEffect } from "react";

export function SentryInit(): null {
  useEffect(() => {
    // Dynamically import Sentry client config to ensure it only runs on client
    if (typeof window !== "undefined") {
      import("../sentry.client.config");
    }
  }, []);

  return null;
}
